import axios from "axios";

const api = axios.create({
    baseURL: "https://wildberries-web-test.up.railway.app/api",
    // baseURL: "http://localhost:5001/api",
    headers: {
        "ngrok-skip-browser-warning": "true"
    }
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("token");
    if (token) {
        config.headers.Authorization = `Bearer ${JSON.parse(token)}`;
    }
    return config;
}, (error) => Promise.reject(error));

export const fetchProducts = async () => {
    const response = await api.get("/products");
    return response.data;
}

export const getSingleProduct = async (id) => {
    const response = await api.get(`products/${id}`)
    return response.data;
}

export const updateProduct = async (id, productData) => {
    const response = await api.put(`/products/${id}`, productData, {
        headers: { "Content-Type": "multipart/form-data" },
    });
    console.log(response.data)
    return response.data;
};

export const createProduct = async (productData) => {
    const response = await api.post("/products", productData, {
        headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
};

export const deleteProduct = async (id) => {
    const response = await api.delete(`/products/${id}`);
    return response.data;
};

export const fetchOrders = async () => {
    const response = await api.get("/orders");
    return response.data;
};

export const fetchOrderById = async (id) => {
    const response = await api.get(`/orders/${id}`);
    return response.data;
};

export default api;